import { Grid, Stack, Typography } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { dateformat } from '../../../../helpers';

const TextFiltrosRecibosComponent = () => {
  const recibosStore = Redux.useSelector((state) => state.recibos);

  const seccionesStore = Redux.useSelector((state) => state.secciones);
  const estatusStore = Redux.useSelector((state) => state.estatus);

  const seccionData = seccionesStore.all.find(
    (el) => el.id === recibosStore.params.idSeccion,
  );
  const estatusData = estatusStore.all.find(
    (el) => el.id === recibosStore.params.idEstatus,
  );

  const fechaIgual = recibosStore.params.desde === recibosStore.params.hasta;

  return (
    <Grid container spacing={1}>
      <Grid item md={12}>
        <Stack direction="row" sx={{}}>
          <Typography variant="caption" color="initial" sx={{ mr: 2 }}>
            <strong>Fecha tope {fechaIgual ? ':' : ' desde:'}</strong>{' '}
            {dateformat(recibosStore.params.desde, { standard: true })}
            {!fechaIgual && (
              <Typography variant="caption" color="initial">
                <strong> hasta </strong>{' '}
                {dateformat(recibosStore.params.hasta, { standard: true })}
              </Typography>
            )}
          </Typography>
          {seccionData ? (
            <Stack direction="row" sx={{}}>
              <Typography variant="caption" color="initial" sx={{ mr: 2 }}>
                <strong>Nivel:</strong>{' '}
                {seccionData.nivelAcademico.nivelAcademico.nombre}
              </Typography>
              <Typography variant="caption" color="initial" sx={{ mr: 2 }}>
                <strong>Sección:</strong> {seccionData.nombre}
              </Typography>
              <Typography variant="caption" color="initial" sx={{ mr: 2 }}>
                <strong>Turno:</strong> {seccionData.turno}
              </Typography>
            </Stack>
          ) : (
            <Typography variant="caption" color="initial" sx={{ mr: 2 }}>
              <strong>Sección:</strong> Todos
            </Typography>
          )}
          <Typography variant="caption" color="initial" sx={{ mr: 2 }}>
            <strong>Estatus:</strong>{' '}
            {estatusData ? estatusData.nombre : 'TODOS'}
          </Typography>
        </Stack>
      </Grid>
    </Grid>
  );
};

export default TextFiltrosRecibosComponent;
